<script lang="ts">
  import { entityStore, setUIState, entityId } from '$lib/stores/entityStore';
  import type { PutEntityRequest, GetEntityResponse } from '$lib/models/entity/types';
  import Button from '$lib/components/common/button/Button.svelte';
  import { getErrorMessage, isErrorResponse } from '$lib/utils/error/errorUtils';
  import { getToastStore } from '@skeletonlabs/skeleton';
  import { createEventDispatcher, onMount } from 'svelte';
  export let clientId: number;

  const dispatch = createEventDispatcher();
  const toastrStore = getToastStore();
  
  let loading = false;

  let name = '';
  let entityKey = '';
  let entityProductKey = '';
  let currency = '';

  async function loadEntityData(): Promise<void> {
    try {
      const result = await entityStore.fetchById(clientId, $entityId ?? 0);
      if (isErrorResponse(result)) {
        toastrStore.trigger({
          message: getErrorMessage(result),
          background: 'bg-error-500',
        });
      } else {
        const entity: GetEntityResponse = result;
        name = entity.name;
        entityKey = entity.entityKey;
        entityProductKey = entity.entityProductKey;
        currency = entity.currency;
      }
    } catch (errors) {
      for (let error of errors) {
        toastrStore.trigger({
          message: `${error.key} - ${error.value}`,
          background: 'bg-error-500',
          classes: 'text-white',
        });
      }
    }
  }

  async function updateEntity(): Promise<void> {
    const updatedEntity: PutEntityRequest = {
      id: $entityId ?? 0,
      clientId: clientId,
      name,
      entityKey,
      entityProductKey,
      currency
    };

    loading = true;

    try {
      await entityStore.update(updatedEntity);
      setUIState('DataTable');
    } catch (errors) {
      for (let error of errors) {
        toastrStore.trigger({
          message: `${error.key} - ${error.value}`,
          background: 'bg-error-500',
          classes: 'text-white',
        });
      }
    } finally {
      loading = false;
    }
  }

  onMount(async () => {
    await loadEntityData();
  });
</script>

<div class="card my-6 bg-[#FAFAFC] p-6">
  <div class="mb-5 text-lg font-bold text-primary-500">Update Entity</div>

  <div class="grid grid-cols-2 gap-4 border border-[#EEEEEE] bg-[#FFFFFF] p-5 rounded-container-token">

    <!-- Name -->
    <div class="col-span-1 flex flex-col">
      <label for="name" class="mb-2 text-sm text-gray-700">Name</label>
      <input type="text" id="name" placeholder="" bind:value={name} class="input" />
    </div>

    <!-- EntityKey -->
    <div class="col-span-1 flex flex-col">
      <label for="entityKey" class="mb-2 text-sm text-gray-700">Entity Key</label>
      <input type="text" id="entityKey" placeholder="" bind:value={entityKey} class="input" readonly/>
    </div>

    <!-- Currency -->
    <div class="col-span-1 flex flex-col">
      <label for="currency" class="mb-2 text-sm text-gray-700">Currency (e.g. AUD, GDP)</label>
      <input type="text" id="currency" placeholder="" bind:value={currency} class="input" />
    </div>

    <!-- Entity Product Key -->
    <div class="col-span-1 flex flex-col">
      <label for="entityProductKey" class="mb-2 text-sm text-gray-700">Entity Product Key</label>
      <input type="text" id="entityProductKey" placeholder="" bind:value={entityProductKey} class="input" readonly/>
    </div>


    <!-- Action Buttons -->
    <div class="col-span-2 mt-4 flex justify-end space-x-4">
      <Button label="Cancel" size="medium" variant="outlined" onClick={() => dispatch('entityUpdated')} />
      <Button label="Update Entity" colour="primary" size="medium" onClick={updateEntity} disabled={loading} />
    </div>
  </div>
</div>
